import React, { useState } from 'react';

// mui
import { Box } from '@mui/material';

// components
import { LoiseFiltersFilters, LoiseFiltersFilterOptions, PillTabs } from '../..';

const FILTER_TABS = [
    { value: 'types', label: 'Types' },
    { value: 'options', label: 'Options' },
];

function LoiseFilters(props) {
    const [tab, setTab] = useState('types');
    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <PillTabs value={tab} onChange={setTab} tabs={FILTER_TABS} />
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                {tab === 'types' ? <LoiseFiltersFilters {...props} /> : <LoiseFiltersFilterOptions {...props} />}
            </Box>
        </Box>
    );
}

export { LoiseFilters };
